"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// export const PROJECT_NOT_FOUND = BASE.sub("/*", NotFound);
